// Libs
import { useTranslation } from 'react-i18next';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Style
import './RenderCgu.scss';
// Lang
import { nsSession } from '@/app/i18n/namespaces';

/**
 * @returns {JSX} BodyCgu
 */
function RenderCgu() {
    // Translation
    const { t: translate } = useTranslation(nsSession);

    // CGU articles
    const articles = translate('mfa.cgu.articles', { returnObjects: true });

    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);

    const checkInfoValidity = (info) => {
        return (info ? `${info}` : '');
    };
    const getPortalAddress = () => {
        return window.location.toString().replace(/(^\w+:|^)\/\//, '').split('/')[0];
    };

    // Render
    return (
        <div>
            <Entity entity='mfa.cgu_title' namespace={nsSession} />
            <div className='cgu'>
                <h1>{translate('mfa.cgu.title')}</h1>
                <div>{translate('mfa.cgu.sub_title')}
                    <a className='text-underline' rel='noopener noreferrer' target='_blank' href='https://www.mesticketscb.com/'>www.mesticketscb.com</a>.
                </div>
                {Object.entries(articles).map(([key, article]) => {
                    return article ? (
                        <div key={key}>
                            <h4>{article.title}</h4>
                            {article.content &&
                                article.content.map((item, index) => {
                                    const text = item.text
                                        ?.replace('{{rootOrganization.legalName}}', checkInfoValidity(rootOrganization.legalName))
                                        ?.replace('{{rootOrganization.address}}', checkInfoValidity(rootOrganization.address))
                                        ?.replace('{{rootOrganization.registrationNumber}}', checkInfoValidity(rootOrganization.registrationNumber))
                                        ?.replace('{{getPortalAddress()}}', getPortalAddress());

                                    switch (item.type) {
                                        case 'text':
                                            return (
                                                <div key={`${text}-${index}`}>
                                                    {text}
                                                    {item.separator && <div className='separator'></div>}
                                                </div>
                                            );
                                        case 'textLink':
                                            return (
                                                <div key={`${text}-${index}`}>
                                                    {item.label}
                                                    <a className='text-underline' href={item.href}>
                                                        {text}
                                                    </a>
                                                    {item.separator && <div className='separator'></div>}
                                                </div>
                                            );
                                        case 'highlight':
                                            return (
                                                <div key={`${text}-${index}`}>
                                                    {item.label}
                                                    <span className='highlighted-text'>{text}</span>
                                                    {item.separator && <div className='separator'></div>}
                                                </div>
                                            );
                                        case 'link':
                                            return (
                                                <div key={`${text}-${index}`}>
                                                    {item.text}
                                                    <a className='text-underline' href={item.href.replace('{{getPortalAddress()}}', getPortalAddress())}>
                                                        {item.label.replace('{{getPortalAddress()}}', getPortalAddress())}
                                                    </a>
                                                    {item.separator && <div className='separator'></div>}
                                                </div>
                                            );
                                        default:
                                            return null;
                                    }
                                })
                            }
                        </div>
                    ) : null;
                })}
            </div>
        </div>
    );
}

export default RenderCgu;